import { ReactNode } from 'react'

import { Avatar } from '@/components/ui/avatar'
import { Flex } from '@/components/ui/flex'
import { Typography } from '@/components/ui/typography'

import { getPersonAvatarSrc } from './person-avatar'
import { getPersonFullName, PersonUser } from './person-table.utils'

interface PersonProfileProps {
  // Note: rendered on the right of the profile row, e.g. an actions menu
  actions?: ReactNode
  subtitle?: string | null
  user: PersonUser
}

export const PersonProfile = ({ actions, subtitle, user }: PersonProfileProps) => {
  const fullName = getPersonFullName(user)

  return (
    <Flex align="flex-start" gap={16} justify="space-between">
      <Flex align="center" gap={16}>
        <Avatar
          zoomable
          alt={fullName}
          shape="square"
          size="large"
          src={getPersonAvatarSrc(user.avatar)}
        />
        <div>
          <Typography color="black800" size="text-large" weight="semibold">
            {fullName}
          </Typography>
          {subtitle && (
            <Typography color="black500" size="text-small" weight="medium">
              {subtitle}
            </Typography>
          )}
        </div>
      </Flex>
      {actions}
    </Flex>
  )
}
